module.exports = __webpack_public_path__ + "static/media/ss_5_jp.0442b39a.jpg";